export interface ICreditCheckFlow {
        code: string;
        name: string;
    }

    export class CreditCheckFlow implements ICreditCheckFlow {
        code: string;
        name: string;
    }